import React from 'react'
import { connect } from 'react-redux';
import { change as changeFieldValue } from 'redux-form';
import Endereco from './Endereco';
import selecionarEndereco from '../../actions/endereco/selecionarEndereco';
import ModalCadastroEnderecoPessoa from './ModalCadastroEnderecoPessoa';
import AtualizarCadastroPessoa from './AtualizarCadastroPessoa';

export class Pessoa extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      botaoEditarHabilitado: false
    }
  }

  campoDesabilitado(label, valor) {
    return (
      <div className="vx-enc-person-field">
        <span className="vx-enc-person-field-label">{label}</span>
        <span className="vx-enc-person-field-value">{valor || '—'}</span>
      </div>
    )
  }

  exibirEnderecos() {
    if (this.props.pessoa.enderecos) {
      return (
        <div className="vx-enc-address-grid">
          {this.props.pessoa.enderecos.map(endereco => (
            <Endereco key={endereco.id}
              endereco={endereco}
              selecionarEndereco={this.props.selecionarEnderecoRemetenteDestinatario}
              enderecoSelecionado={this.props.enderecoSelecionado} />
          ))}
        </div>
      )
    }
  }

  limparFormularioEndereco() {
    this.props.selecionarEndereco({})
  }

  exibirBotaoNovoEndereco() {
    return (
      <div className="vx-enc-section-header" style={{ marginTop: 20 }}>
        <div className="vx-enc-section-title">
          <i className="material-icons">home</i>
          Selecione um Endereço
        </div>
        <button data-toggle="modal" data-target="#modalCadastrarEnderecoPessoa"
          className="vx-btn-secondary"
          onClick={this.limparFormularioEndereco.bind(this)}>
          <i className="material-icons">add</i>
          Novo Endereço
        </button>
      </div>
    )
  }

  preencherFormAtualizarCadastroPessoa() {
    this.props.changeFieldValue('formularioAtualizarCadastroPessoa', 'nome', this.props.pessoa.nome);
    this.props.changeFieldValue('formularioAtualizarCadastroPessoa', 'telefone', this.props.pessoa.telefone);
    this.props.changeFieldValue('formularioAtualizarCadastroPessoa', 'ie', this.props.pessoa.inscEstadual);
  }

  habilitarDesabilitarBotao(valor) {
    this.setState({ botaoEditarHabilitado: valor })
  }

  exibeBotaoEditar() {
    return (
      <button type="button" className="vx-btn-secondary" style={{ marginTop: 10 }}
        onClick={() => this.habilitarDesabilitarBotao(true)}>
        <i className="material-icons">edit</i>
        Editar
      </button>
    )
  }

  render() {
    return (
      <React.Fragment>
        <div className="vx-enc-card">
          <div className="vx-enc-card-header">
            <i className="material-icons">person</i>
            <span className="vx-enc-card-title">{this.props.pessoa.nome || 'Dados da Pessoa'}</span>
          </div>
          <div className="vx-enc-card-body">
            {!this.state.botaoEditarHabilitado ? (
              <>
                <div className="vx-enc-person-grid">
                  {this.campoDesabilitado('Nome', this.props.pessoa.nome)}
                  {this.campoDesabilitado('Telefone', this.props.pessoa.telefone)}
                  {this.campoDesabilitado('Inscrição Estadual', this.props.pessoa.inscEstadual)}
                </div>
                {this.exibeBotaoEditar()}
              </>
            ) : (
              <>
                {this.preencherFormAtualizarCadastroPessoa()}
                <AtualizarCadastroPessoa pessoa={this.props.pessoa}
                  buscarPessoa={this.props.buscarPessoa}
                  habilitarDesabilitarBotao={this.habilitarDesabilitarBotao.bind(this)} />
              </>
            )}
            {this.exibirBotaoNovoEndereco()}
            {this.exibirEnderecos()}
          </div>
        </div>
        <ModalCadastroEnderecoPessoa pessoa={this.props.pessoa} buscarPessoa={this.props.buscarPessoa} />
      </React.Fragment>
    )
  }
}

export default connect(null, { selecionarEndereco, changeFieldValue })(Pessoa);
